<template>
<div >

	<Navbar></Navbar>
	<div class="main-content">
		<Loader :show="loading"></Loader>
		<div class="container" v-if="!loading">
			
			<div class="card mt-2">
				<div class="card-body">
		
					<div class="page-header">
						<ol class="breadcrumb">
							<li class="breadcrumb-item">GENERAL</li>
							<li class="breadcrumb-item active">Traslados</li>
						</ol>
						<div class="title">
							<h1>Traslados</h1>
						</div>
						<!-- <div class="cta">
							<b-dropdown text="Acciones" right  variant="light" >
								<div @click="exportData()" class="dropdown-item" >Exportar listado</div>
							</b-dropdown>
						</div> -->
					</div>

						
					<div class="filters-box">
						<div class="filter">
							<label>BUSCAR</label>
							<input 
								type="text" 
								class="form-control" 
								placeholder="Buscar" 
								v-model="filters.search" 
								@keyup.enter="updateFilters($event)">
						</div>
						<div class="filter">
							<label>Fecha</label>
							<date-picker range
								v-model="filters.dates" 
								:value-type="'YYYY-MM-DD'"
								:format="'DD-MM-YYYY'"
								@change="updateFilters()"
							></date-picker>
						</div>
						<div class="filter">
							<label>Usuario</label>
							<select class="form-control" 
								v-model="filters.user" 
								@change="updateFilters($event)">
								<option value="">Todos</option>
								<option :value="user.id" v-for="user in users" :key="user.id">{{user.name}}</option>
							</select>
						</div>
						
						<!-- <div class="btn btn-light " @click="exportData()">Exportar</div> -->
					</div>

					<table class="table ">
						<tr class="table-head">
							<td>Chasis</td>
							<td>Vehículo</td>
							<td>Inicio</td>
							<td>Cierre</td>
						</tr>
						
						<tr v-for="item of list" :key="item.id" @click="openPreview(item.id)" >
							<td>{{item.chassis_number}}</td>
							<td>
								<div class="tc">
									<span class="text-primary">{{item.brand}}</span>
									<span >{{item.model}}</span>
								</div>
							</td>
							<td>
								<div class="tc">
									<span class="text-primary" v-if="item.checkOut">{{item.checkOut | moment("DD-MM-YYYY HH:mm")}}</span>
									<span v-if="item.checkOutLocation">{{item.checkOutLocation}}</span>
								</div>
							</td>
							<td>
								<div class="tc" v-if="item.checkIn">
									<span class="text-primary" >{{item.checkIn | moment("DD-MM-YYYY HH:mm")}}</span>
									<span >{{item.checkInLocation}}</span>
								</div>
								<div class="tc" v-else>
									<span class="text-secondary" >No definida</span>
								</div>
							</td>
							<td>
								<div class="tc">
									<span v-if="item.status=='ON_COURSE'"><div class="car-status-point DELIVERY_SCHEDULED"></div>{{item.statusText}}</span>
									<span v-if="item.status=='DONE'"><div class="car-status-point DELIVERED"></div>{{item.statusText}}</span>
								</div>
							</td>
						</tr>
						
					</table>

					<div class="alert alert-info text-center" v-if="list.length==0" >No se han encontrado traslados</div>
					
					<vue-ads-pagination v-if="pagination"
						:total-items="pagination.total"
						:max-visible-pages="2"
						:items-per-page="pagination.length"
						:page="pagination.page-1"
						@page-change="pageChange"					
					></vue-ads-pagination>
				</div>
			</div>
		</div>
	</div>

	<TransferPreview ref="transferPreview"></TransferPreview>

</div>
</template>

<script>
import gql from 'graphql-tag'
import listMixins from '@/mixins/listMixins'

import Navbar from '@/components/Navbar'
import Loader from '@/components/Loader'
import TransferPreview from './TransferPreview'

export default {
	name: 'transfers',
	components:{
		Navbar,
		Loader,
		TransferPreview,
	},
	mixins:[listMixins],
	data () {
		return {
			list:[],
			loading: true,
			users:[],
		}
	},
	beforeMount(){
		this.filters = this.getValidUrlParams();
		this.load();
	},
	methods:{
		// exportData(){
		// 	const params = new URLSearchParams(this.$route.query).toString();
		// 	const url = `https://terminal.com.uy/exportables/export-controls.php?${params}`
		// 	window.open(url, '_blank');
		// },
		load(){
			this.$apollo.query({
				query: gql`query ($first: Int!, $page: Int, $search: String, $type: String, $dates:[Date], $user: String) {
					transfers(first: $first, page: $page, search: $search, type: $type, dates: $dates, user: $user) {
						paginatorInfo {
							count
							currentPage
							total
						}
						data {
							id
							type
							typeText
							checkOut
							checkOutLocation
							checkIn
							checkInLocation

							user{
								name
							}
							chassis_number
							model
							brand
							statusText
							status
							created_at
						}
					},
					usersAll{
						id
						name
						email
					},
				}`,
				variables: {
					page: this.pagination.page,
					first: this.pagination.length,
					search: this.filters.search,
					type: this.filters.type,
					dates: this.filters.dates,
					user: this.filters.user,
				},
			})
			.then((data) => {
				this.list = data.data.transfers.data;
				this.pagination.total = data.data.transfers.paginatorInfo.total;
				this.users = data.data.usersAll;
				this.loading = false
			});
		},
		openPreview(id){
			this.$refs.transferPreview.open(id)
		},

	}
}


</script>

<style>

</style>
